import { Box } from "@chakra-ui/react";
import { defaultScroll } from "chakra/theme";

export function CodeBlock({ value }: { value: object | object[] }) {
  return (
    <Box
      as="pre"
      bg="#1E1E2E"
      color="#CDD6F4"
      p="14px"
      borderRadius="10px"
      fontSize="12px"
      overflow="auto"
      maxH="340px"
      css={defaultScroll as any}
      fontFamily="monospace"
      whiteSpace="pre-wrap"
      wordBreak="break-word"
    >
      {JSON.stringify(value, null, 2)}
    </Box>
  );
}
